export class BaseDataApiModel {
  public id: string;
  public value: string;
  public parent_id: string;
  public base_data_key: string;
}
